export const removeDynamicOauthParamsFromUrl = (url: string) => {
  const urlObject = new URL(url);

  urlObject.searchParams.delete('dynamicOauthState');
  urlObject.searchParams.delete('dynamicOauthCode');

  return urlObject.toString();
};
